// extracted by mini-css-extract-plugin
export default {"Table":"styles_Table__Xezq+","Actions":"styles_Actions__PpGfV","DropDown":"styles_DropDown__JX9Tq","Tabs":"styles_Tabs__CqJa6","All":"styles_All__UdCbR"};